import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';

const ltrCache = createCache({
    key: 'mui',
});

const LtrProvider = ({ children }) => {
    return (
        <div dir="ltr">
            <CacheProvider value={ltrCache}>{children}</CacheProvider>
        </div>
    );
};

export default LtrProvider;
